import { API_BASE_URL } from '../services/api';
import { computeCpuFingerprint } from './fingerprint';

const DEVICE_TOKEN_KEY = 'enantio-device-token';
const DEVICE_TOKEN_EXP_KEY = 'enantio-device-token-exp';


export const readCachedDeviceToken = (): string | null => {
  const token = localStorage.getItem(DEVICE_TOKEN_KEY);
  const exp = parseInt(localStorage.getItem(DEVICE_TOKEN_EXP_KEY) || '0', 10);
  if (token && exp && Date.now() < exp) {
    return token;
  }
  return null;
};

export const ensureDeviceToken = async (): Promise<string> => {
  const cached = readCachedDeviceToken();
  if (cached) return cached;

  const { bits36 } = await computeCpuFingerprint();
  const ua = navigator.userAgent;
  const res = await fetch(`${API_BASE_URL}/api/device/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bits36, ua }),
  });
  if (!res.ok) throw new Error('Failed to register device');
  const data = await res.json();
  const token: string = data.device_token;
  if (token) {
    let exp = 0;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload?.exp) exp = payload.exp * 1000;
    } catch {}
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
    if (exp) localStorage.setItem(DEVICE_TOKEN_EXP_KEY, String(exp));
  }
  return token;
};

